import { IconButton } from '@mui/material';
import { FunctionComponent } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { DialogButton } from 'src/components/elements/DialogButton';
import { addNote } from '../api/addNote';
import { Note } from '../types/note';
import { NoteForm } from './NoteForm';
import AddIcon from '@mui/icons-material/Add';

export const AddNoteButton: FunctionComponent<{}> = () => {
  return (
    <DialogButton
      label="Add"
      button={
        <IconButton>
          <AddIcon />
        </IconButton>
      }
    >
      {(closeDialog) => <AddNoteForm closeDialog={closeDialog} />}
    </DialogButton>
  );
};

const AddNoteForm: FunctionComponent<{
  closeDialog: () => void;
}> = ({ closeDialog }) => {
  const queryClient = useQueryClient();
  const addMutation = useMutation(addNote, {
    onSuccess: () => queryClient.invalidateQueries('notes'),
  });

  return (
    <NoteForm
      initialData={new Note()}
      title="Add"
      onSaveClick={(note: Note) =>
        addMutation.mutate(note, {
          onSuccess: closeDialog,
        })
      }
      closeDialog={closeDialog}
    />
  );
};
